
// SVG Icon: one-two-three
export default { id: "terriajs-one-two-three" };
export const id = "terriajs-one-two-three";
export const name = "one-two-three";
